import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/star_battle.json";
import fr from "@/locales/fr/puzzle-types/star_battle.json";

export const STAR_BATTLE_NS = "puzzle-types/star_battle";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerStarBattleTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", STAR_BATTLE_NS))
    i18n.addResourceBundle("en", STAR_BATTLE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", STAR_BATTLE_NS))
    i18n.addResourceBundle("fr", STAR_BATTLE_NS, fr, true, true);
}
